/*
 * fn: parseAdvancedRoute
 *
 * Parses URL search params from a given route object's advanced filters
 *
 */

import {
  FILTER_ADVANCED_MAX,
  type FilterAdvancedType,
  isFilterAdvancedCountNumberType,
  isFilterAdvancedCountSlugType,
  isFilterAdvancedCountValueOperatorsType,
  isFilterAdvancedPriceNumberType,
  isFilterAdvancedPriceSlugType,
  isFilterAdvancedPriceValueOperatorsType,
} from '@/defs/filters'

export const parseAdvancedRoute = (filterQuery: string) => {
  if (!filterQuery) return

  return decodeURIComponent(filterQuery)
    .split(';')
    .map((item): FilterAdvancedType | false => {
      const [slug, value] = item.split('=')
      if (!slug || !value) return false
      switch (slug) {
        case 'in': {
          return { card: value, slug: 'withCard' }
        }
        case 'out': {
          return { card: value, slug: 'withoutCard' }
        }
        default: {
          const number = Number(value)
          const [category, operator] = slug.split(':')
          if (!Number.isInteger(number) || !category || !operator) return false

          if (
            isFilterAdvancedCountSlugType(category) &&
            isFilterAdvancedCountValueOperatorsType(operator) &&
            isFilterAdvancedCountNumberType(number)
          ) {
            return { number, operator, slug: category }
          }

          if (
            isFilterAdvancedPriceSlugType(category) &&
            isFilterAdvancedPriceValueOperatorsType(operator) &&
            isFilterAdvancedPriceNumberType(number)
          ) {
            return { number, operator, slug: category }
          }

          return false
        }
      }
    })
    .filter((f) => !!f)
    .slice(-FILTER_ADVANCED_MAX)
}
